import { render, staticRenderFns } from "./CardSubjectResult.vue?vue&type=template&id=736bc354&scoped=true&"
import script from "./CardSubjectResult.vue?vue&type=script&lang=ts&"
export * from "./CardSubjectResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736bc354",
  null
  
)

export default component.exports